export default __webpack_public_path__ + "static/media/DesativarFalha.901e7e68.svg";